import React, { useRef } from 'react'
import { useDrag, useDrop } from 'react-dnd'
const ItemTypes = {
    CARD: 'card',
  }
const style = {




  cursor: 'move',
}
const TargetBox = ({ accept, dragType, id, index, moveCard, children, onDrop }) => {
  const ref = useRef(null)
  const [{ isOver, canDrop }, drop] = useDrop({
    accept,
    drop: onDrop,
    collect: (monitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    hover(item, monitor) {
       // console.log('item', item)
        if (item.type === 'group') {
            return
        }
      if (!ref.current) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect()
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      // Determine mouse position
      const clientOffset = monitor.getClientOffset()
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex)
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex
    },
  })

  const isActive = isOver && canDrop
  let backgroundColor = '#f7f7f7'
  if (isActive) {
    backgroundColor = '#40C4FF'
  } else if (canDrop) {
    backgroundColor = '#40C4FF'
  }

  const [{ isDragging }, drag] = useDrag({
    type: dragType,
    item: { type: dragType, id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })
  const opacity = isDragging ? 0 : 1
  drag(drop(ref))
  return (
    <div ref={ref} style={{ ...style, opacity }}>
      {children}
    </div>
  )
};

export default TargetBox;
